import { fromJS } from 'immutable';

import { fetchLabelFormatsRoutine } from '../routines';

const initialState = fromJS({
  labelFormats: [],
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case fetchLabelFormatsRoutine.SUCCESS:
      return state.set('labelFormats', fromJS(action.payload.response));
    case fetchLabelFormatsRoutine.FAILURE:
      return state.setIn(['labelFormats', 'loading'], false);
    // case saveLabelFormatRoutine.SUCCESS:
    //   return state.updateIn(['labelFormats','data'], updateOrAdd(fromJS(action.payload.response.data)));
    // case removeLabeloutine.SUCCESS:
    //   return state.updateIn(['labelFormats','data'], remove(fromJS(action.payload.request)));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/labelformats.js